import { APIFactory } from "cw-galatea-api-js/cw-galatea-api-js-bundle.js";
import { SingletonSharedData } from "./Singletons/SingletonSharedData";
import { SingletonCallOutData } from "./Singletons/SingletonCallData";
import { AgentControllerFactory } from "cw-galatea-agent-controller-js/cw-galatea-agent-controller-js-bundle.min.js";
import { UtilityFactory } from "global-common-utilities-js/global-common-utilities-js-bundle.js";
import { messageLogin,RequestedLogout, Reconnected, triggerNotifications, messageRetryFirstCall} from '../js/Helpers/helperMessages';
import {
  SOFTPHONE_VALIDATING,
  SOFTPHONE_CALLBACKS,
  SOFTPHONE_MAKECALL,
  SOFTPHONE_PARAMETERS,
} from "../js/Strategies/Strategies_SoftPhone";
import { SMResponseHelper } from "./Helpers/SMResponseHelper";
import {
  SOFTPHONES_KEY,
  SM_QUEUE_SERVER,
  API_ENDPOINTS,
  LIST_STATES,
  SHOW_TRANSFERS_BUTTONS,
  SHOW_TRANSFERS_BUTTONS_DEFAULT,
  STATE_TO_PLAY_END_AUDIO,
  SHOW_TRANSFERS_BUTTONS_REFERENCE,
  USER_STATE,
  DISPOSITIONS_ACTIONS,
  UNAVAILABLES_ACTIONS,
} from "./constants/constants";
import { helperLanguage } from "./Helpers/helperLanguage";
import { changePassword, loginAgent } from "./components/login";
import { ProcessMessage } from './components/ProcessMessage';
import { STRATEGIES_STATES } from '../js/Strategies/StrategiesStates';
import { setSvrReady, setSvrReadyWithPassword, svrRequestUnavailables} from "./components/unavailables";
import { getSvrCallsHistory, getSvrUnavailablesHistory } from "./components/historyEvents";
import { makeSvrManualCall, svrCancelScheduledManualCall, svrHangUpManualCall } from "./components/manualCall";
import { setSvrdigitDTMF, setSvrHoldCall, setSvrMute, setSvrStopStartRecording, setSvrVolumen, svrHangUpAndLeaveMessage } from "./components/callControls";
import { getSvrXferOptions } from "./components/transferOptions";
import { makeSvrBlindTransferCallToAgent, makeSvrBlindTransferCallToDirectory, makeSvrBlindTransferCallToInboundCamp, makeSvrBlindTransferCallToManualNumber } from "./components/blindTransfer";
import { makeSvrAssistedTransferCallToAgent, makeSvrAssistedTransferCallToDirectory, makeSvrAssistedTransferCallToInboundCamp, makeSvrAssistedTransferCallToManualNumber, makeSvrAssistedTransferSwitchPrimaryCall, makeSvrAssistedTransferSwitchSecondaryCall, makeSvrAssistedTransferCreateConference, makeSvrAssistedTransferCall, handleSvrAssistedTransferLeaveConference,handleSvrAssistedTransferHangupCall, handleSvrAssistedTransferHangupSecondCall} from "./components/assitedTransfer";
import { setSvrUpdateData } from "./components/updateData";
import {  requestDispositions, saveSvrDisposition } from "./components/dispositions";
import { getSvrCallbacks, reprogramToServer } from "./components/reprogramCall";
import { MESSAGE_CODE, MESSAGE_FROM, MESSAGE_TYPE } from "./constants/Notifications";
import { getAudioPath } from "./components/audiosSDK";
import { svrGetAdminsToChat, svrGetChatLog, svrSendChatToAdmin } from "./components/chatToAdmin";
import { initEvents } from "./events/initEvents";
import { errorEvents } from "./events/errorEvent";
import { svrGetIVRList, svrStartIVR } from "./components/ivrActions";
import { VERIFY_ACTIONS, verifyState } from "./constants/validateFunctions";

let instance = null;
export class AgentSDK {
  constructor() {

    if (!instance) {
      instance = this;
    }
    this.serverIp = "";
    this.state = {
      isLogged: false,
      consulting: 0,
      callType: 1,
      idChangeCount: -1,
      queueCount: 0,
      timeInQueue: 0,
      alert: null,
      newAlertCode: 0,
      newAlertMessage: null,
      dataCall: {},
      extraDataCall: {},
      loginError: 0,
      isInConference: false,
      loadedLanguaje: false,
      softPhoneLoaded: false,
      smReady: true,
      dialogShow: false,
      dialogContent: {},
    };
    this.dateSendMessage = { date: new Date(), message: null };
    this.numberReconnect = 0;
    this.Engines = {};
    this.sharedCallOutData = new SingletonCallOutData();
    this.sharedData = new SingletonSharedData();
    this.smResponseHelper = new SMResponseHelper();
    this.smResponseHelper.setThat(this);
    this.rabbitConnected = false;
    this.telephonyTime = 0;
    let APIFact = new APIFactory();
    this.apiCont = APIFact.buildClient();
    this.agentFact = new AgentControllerFactory();
    this.callId = 0;
    let utilityFactory = new UtilityFactory();
    this.urlClient = utilityFactory.buildURLClient();
    this.initEvents();
    this.errorEvents();
  }

  initEvents = () => {
    this.svrEvents = {};
    const events = initEvents;
    this.updateSvrEvents(events);
  }
  errorEvents = () => {
    this.errorEvents = {};
    const events = errorEvents;
    this.updateErrorEvents(events);
  }
  notifications = () =>{
    this.notifications = {};
    const info = { notificationsManager: () => console.log("messageNotification") };
    this.updateNotifications(info);
  }

  updateSvrEvents(settings) {
    Object.keys(settings).forEach(key => this.svrEvents[key] = settings[key]);
  }
  updateErrorEvents(settings) {
    Object.keys(settings).forEach(key => this.errorEvents[key] = settings[key]);
  }

  updateNotifications(settings) {
    Object.assign(this.notifications, settings);
  }

  login = (user, password) => {
    if(verifyState(VERIFY_ACTIONS.LOGIN, this.sharedData.currentState)){
      let AgentFact = new AgentControllerFactory();
      let softphoneKey = SOFTPHONES_KEY.WEBRTC;
      let rabbitMqTest = null;
      rabbitMqTest = { isWebStomp: true };
      this.agentController = AgentFact.buildClient(softphoneKey, rabbitMqTest.isWebStomp);
      loginAgent(user,password, this);
    }else{
      triggerNotifications(this, MESSAGE_CODE.LOGIN[10000], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
    }
  };

  logout = () =>{
    this.sharedData.isProblemStatus = false;
    if ((this.sharedData.getCurrentState() === 'Wrapup' || this.sharedData.getCurrentState() === 'Dialog') && !this.sharedData.getIsRated()) {
			console.warn('The call:' + this.callId + ' was not rated. Reason: Logout, LastState:' + this.sharedData.getCurrentState());
		}

    let isLogin = this.sharedData.getUserData();
    if(!isLogin){
      console.warn('Not login.');
      return ;
    }
    this.sendToRabbit(SM_QUEUE_SERVER, RequestedLogout());
    this.agentController.disconnectBroker();
    setTimeout(() => {
      location.reload();
    }, 1500);
  }

  setDomain = (domain, isHttps) => {
      this.sharedData.setDomain(domain);
      if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
        this.apiCont.PathWS = `http${isHttps ? "s" : ""}://${this.sharedData.getDomain()}/`;
      } else {
        this.apiCont.PathWS = window.location.origin + "/";
      }
      this.sharedData.setSecureConnection(this.apiCont.PathWS.includes("https"));
      console.log(`Route of connect to server: ${this.apiCont.PathWS}`);
      let langHelper = new helperLanguage();
        langHelper.setLanguage(this, '', () => {
        this.sharedData.currentState = 'logout';
        this.svrEvents.onChangeStatus({
          currentState: "Logout",
          action: "state"
        });
      });

      let audio = document.getElementById('audio-call');
      if (!audio) {
        audio = document.createElement('audio');
        audio.id = 'audio-call';
        audio.className = 'audio';
        let body = document.getElementsByTagName('html')[0];
        body.appendChild(audio);
      } else {
        console.log('The audio element already exists in the document.');
      }

  };

  getAgentInfo = () => {
    if(this.sharedData.getUserData()){
      const {Extension} = this.sharedData.getParameters();
      const {Login, User_id} = this.sharedData.getUserData();
      this.svrEvents.onAgentInfo({
        username: Login,
        userId : User_id,
        extensionId : Extension,
      });
    }else{
      console.warn("the session of agent not exists...");
    }
  }

  changePassword = (password,newPassword, confirmPassword) => {
    if(verifyState(VERIFY_ACTIONS.CHANGE_PASSWORD, this.sharedData.currentState)){
      changePassword(password,newPassword, confirmPassword,this);
    }else{
      triggerNotifications(this, MESSAGE_CODE.ACCOUNT_CONFIGURATION[10100], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
    }
  };

  retryFirstCall = () =>{
    this.sendToRabbit(SM_QUEUE_SERVER,messageRetryFirstCall(this.sharedData.getUserData().Login, this.sharedData.getUserData().User_id));
  }


  blindTransferCallToAgent = (ext, callKey) => {
    if(verifyState(VERIFY_ACTIONS.BLIND_TRANSFER, this.sharedData.currentState)){
      const checkToolsTransfer = this.checkToolsTransferOptions(SHOW_TRANSFERS_BUTTONS_REFERENCE.TRANSFER);
      if (!checkToolsTransfer) {
        return;
      }
      makeSvrBlindTransferCallToAgent(this, ext, callKey);
    } else {
      triggerNotifications(this, MESSAGE_CODE.BLIND_TRANSFER[10401], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
    }
    
  }

  blindTransferCallToDirectory = (dirNumber, callKey) =>{
    if(verifyState(VERIFY_ACTIONS.BLIND_TRANSFER, this.sharedData.currentState)){
      const checkToolsTransfer = this.checkToolsTransferOptions(SHOW_TRANSFERS_BUTTONS_REFERENCE.TRANSFER);
      if (!checkToolsTransfer) {
        return;
      }
      makeSvrBlindTransferCallToDirectory(this,dirNumber, callKey);
    } else {
      triggerNotifications(this, MESSAGE_CODE.BLIND_TRANSFER[10401], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
    }
  }

  blindTransferCallToInboundCamp = (inCamp, callKey) => {
    if(verifyState(VERIFY_ACTIONS.BLIND_TRANSFER, this.sharedData.currentState)){
      const checkToolsTransfer = this.checkToolsTransferOptions(SHOW_TRANSFERS_BUTTONS_REFERENCE.TRANSFER);
      if (!checkToolsTransfer) {
        return;
      }
      makeSvrBlindTransferCallToInboundCamp(this, inCamp, callKey);
    } else {
      triggerNotifications(this, MESSAGE_CODE.BLIND_TRANSFER[10401], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
    }

  }
  blindTransferCallToManualNumber = (manualNumber, callKey) => {
    if(verifyState(VERIFY_ACTIONS.BLIND_TRANSFER, this.sharedData.currentState)){
      const checkToolsTransfer = this.checkToolsTransferOptions(SHOW_TRANSFERS_BUTTONS_REFERENCE.TRANSFER);
      if (!checkToolsTransfer) {
        return;
      }
      makeSvrBlindTransferCallToManualNumber(this,manualNumber, callKey);
    } else {
      triggerNotifications(this, MESSAGE_CODE.BLIND_TRANSFER[10401], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
    }
  }
  getXferOptions= () => {
    if(verifyState(VERIFY_ACTIONS.BLIND_TRANSFER, this.sharedData.currentState)){
      const checkToolsTransfer = this.checkToolsTransferOptions(SHOW_TRANSFERS_BUTTONS_REFERENCE.TRANSFER);
      if (!checkToolsTransfer) {
        return;
      }
      getSvrXferOptions(this);
    } else {
      triggerNotifications(this, MESSAGE_CODE.BLIND_TRANSFER[10401], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
    }
  }

  assistedTransferCallToAgent= (ext) => {
    if(verifyState(VERIFY_ACTIONS.ASSISTED_TRANSFER, this.sharedData.currentState)){
      const checkToolsTransfer = this.checkToolsTransferOptions(SHOW_TRANSFERS_BUTTONS_REFERENCE.TRANSFER);
      if (!checkToolsTransfer) {
        return;
      }
      makeSvrAssistedTransferCallToAgent(this,ext);
    } else {
      triggerNotifications(this, MESSAGE_CODE.ASSISTED_TRANSFER[10502], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
    }
  }
  
  assistedTransferCallToDirectory = (dirNumber) => {
    if(verifyState(VERIFY_ACTIONS.ASSISTED_TRANSFER, this.sharedData.currentState)){
      const checkToolsTransfer = this.checkToolsTransferOptions(SHOW_TRANSFERS_BUTTONS_REFERENCE.TRANSFER);
      if (!checkToolsTransfer) {
        return;
      }
      makeSvrAssistedTransferCallToDirectory(this,dirNumber);
    } else {
      triggerNotifications(this, MESSAGE_CODE.ASSISTED_TRANSFER[10502], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
    }
  }

  assistedTransferCallToInboundCamp = (inboundCamp) => {
    if(verifyState(VERIFY_ACTIONS.ASSISTED_TRANSFER, this.sharedData.currentState)){
      const checkToolsTransfer = this.checkToolsTransferOptions(SHOW_TRANSFERS_BUTTONS_REFERENCE.TRANSFER);
      if (!checkToolsTransfer) {
        return;
      }
      makeSvrAssistedTransferCallToInboundCamp(this,inboundCamp);
    } else {
      triggerNotifications(this, MESSAGE_CODE.ASSISTED_TRANSFER[10502], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
    }
  }

  assistedTransferCallToManualNumber = (manualNumber) => {
    if(verifyState(VERIFY_ACTIONS.ASSISTED_TRANSFER, this.sharedData.currentState)){
      const checkToolsTransfer = this.checkToolsTransferOptions(SHOW_TRANSFERS_BUTTONS_REFERENCE.TRANSFER);
      if (!checkToolsTransfer) {
        return;
      }
      makeSvrAssistedTransferCallToManualNumber(this,manualNumber);
    } else {
      triggerNotifications(this, MESSAGE_CODE.ASSISTED_TRANSFER[10502], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
    }
  }

  assistedTransferCallToSecondCall  = () => {
    if(verifyState(VERIFY_ACTIONS.ASSISTED_TRANSFER, this.sharedData.currentState)){
      const checkToolsTransfer = this.checkToolsTransferOptions(SHOW_TRANSFERS_BUTTONS_REFERENCE.TRANSFER);
      if (!checkToolsTransfer) {
        return;
      }
      makeSvrAssistedTransferCall(this);
    } else {
      triggerNotifications(this, MESSAGE_CODE.ASSISTED_TRANSFER[10502], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
    }
  }

  assistedTransferSwitchPrimaryCall  = () => {
    if(verifyState(VERIFY_ACTIONS.ASSISTED_TRANSFER, this.sharedData.currentState)){
      const checkToolsTransfer = this.checkToolsTransferOptions(SHOW_TRANSFERS_BUTTONS_REFERENCE.TRANSFER);
      if (!checkToolsTransfer) {
        return;
      }
      makeSvrAssistedTransferSwitchPrimaryCall(this);
    } else {
      triggerNotifications(this, MESSAGE_CODE.ASSISTED_TRANSFER[10502], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
    }
  }

  assistedTransferSwitchSecondaryCall  = () => {
    if(verifyState(VERIFY_ACTIONS.ASSISTED_TRANSFER, this.sharedData.currentState)){
      const checkToolsTransfer = this.checkToolsTransferOptions(SHOW_TRANSFERS_BUTTONS_REFERENCE.TRANSFER);
      if (!checkToolsTransfer) {
        return;
      }
      makeSvrAssistedTransferSwitchSecondaryCall(this);
    } else {
      triggerNotifications(this, MESSAGE_CODE.ASSISTED_TRANSFER[10502], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
    }
  }

  assistedTransferCreateConference  = () => {
    if(verifyState(VERIFY_ACTIONS.ASSISTED_TRANSFER, this.sharedData.currentState)){
      const checkToolsTransfer = this.checkToolsTransferOptions(SHOW_TRANSFERS_BUTTONS_REFERENCE.TRANSFER);
      if (!checkToolsTransfer) {
        return;
      }
      makeSvrAssistedTransferCreateConference(this);
    } else {
      triggerNotifications(this, MESSAGE_CODE.ASSISTED_TRANSFER[10502], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
    }
  }

  assistedTransferLeaveConference  = () => {
    if(verifyState(VERIFY_ACTIONS.ASSISTED_TRANSFER, this.sharedData.currentState)){
      const checkToolsTransfer = this.checkToolsTransferOptions(SHOW_TRANSFERS_BUTTONS_REFERENCE.TRANSFER);
      if (!checkToolsTransfer) {
        return;
      }
      handleSvrAssistedTransferLeaveConference(this);
    } else {
      triggerNotifications(this, MESSAGE_CODE.ASSISTED_TRANSFER[10502], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
    }
  }

  assistedTransferHangupCall  = () => {
    if(verifyState(VERIFY_ACTIONS.ASSISTED_TRANSFER, this.sharedData.currentState)){
      const checkToolsTransfer = this.checkToolsTransferOptions(SHOW_TRANSFERS_BUTTONS_REFERENCE.TRANSFER);
      if (!checkToolsTransfer) {
        return;
      }
      handleSvrAssistedTransferHangupCall(this);
    } else {
      triggerNotifications(this, MESSAGE_CODE.ASSISTED_TRANSFER[10502], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
    }
  }

  assistedTransferHangupSecondCall  = () => {
    if(verifyState(VERIFY_ACTIONS.ASSISTED_TRANSFER, this.sharedData.currentState)){
      const checkToolsTransfer = this.checkToolsTransferOptions(SHOW_TRANSFERS_BUTTONS_REFERENCE.TRANSFER);
      if (!checkToolsTransfer) {
        return;
      }
      handleSvrAssistedTransferHangupSecondCall(this);
    } else {
      triggerNotifications(this, MESSAGE_CODE.ASSISTED_TRANSFER[10502], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
    }
  }
  toolsTransfersOptions = () => {
    const toolsTransfer = this.sharedData.getToolsTransfer();
    let showTransferOptions = SHOW_TRANSFERS_BUTTONS_DEFAULT;
    if(!toolsTransfer.showOptionsOnTransfer) {
      showTransferOptions = SHOW_TRANSFERS_BUTTONS;
    }
    this.svrEvents.onToolsTransferOptions(showTransferOptions);
  }
  checkToolsTransferOptions = (validateOption) => {
    const isValidOption = SHOW_TRANSFERS_BUTTONS[validateOption];
    const otherState = this.sharedData.currentState === LIST_STATES.OTHER;
    let toolsTransferStatus = true;
    if (otherState && !this.sharedData.isShowToolsTransfersActive && !isValidOption) {
      triggerNotifications(this, MESSAGE_CODE.CALL_CONTROLS[10710], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
      console.log(`[AgentSDK] [checkToolsTransferOptions] : Action not valid: ${validateOption}`);
      toolsTransferStatus = false;
    }
    return toolsTransferStatus;
  }
  changeVolumen = (volSpeaker, volMicrophone) => {
    if(verifyState(VERIFY_ACTIONS.CHANGE_VOLUMEN, this.sharedData.currentState)){
      const checkToolsTransfer = this.checkToolsTransferOptions(SHOW_TRANSFERS_BUTTONS_REFERENCE.VOLUME);
      if (!checkToolsTransfer) {
        return;
      }
      setSvrVolumen(this, volSpeaker, volMicrophone);
    }else{
      triggerNotifications(this, MESSAGE_CODE.CALL_CONTROLS[10700], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
    }
  }
  digitDTMF = (digit) =>{
    if(verifyState(VERIFY_ACTIONS.DIGIT_DTMF, this.sharedData.currentState)){
      const checkToolsTransfer = this.checkToolsTransferOptions(SHOW_TRANSFERS_BUTTONS_REFERENCE.DTMF);
      if (!checkToolsTransfer) {
        return;
      }
      setSvrdigitDTMF(this,digit);
    }else{
      triggerNotifications(this, MESSAGE_CODE.CALL_CONTROLS[10701], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
    }
  }
  holdCall = () =>{
    if(verifyState(VERIFY_ACTIONS.HOLD_CALL, this.sharedData.currentState)){
      const checkToolsTransfer = this.checkToolsTransferOptions(SHOW_TRANSFERS_BUTTONS_REFERENCE.HOLD);
      if (!checkToolsTransfer) {
        return;
      }
      setSvrHoldCall(this);
    }else{
      triggerNotifications(this, MESSAGE_CODE.CALL_CONTROLS[10701], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
    }
  }
  mute = () =>{
    if(verifyState(VERIFY_ACTIONS.MUTE, this.sharedData.currentState)){
      const checkToolsTransfer = this.checkToolsTransferOptions(SHOW_TRANSFERS_BUTTONS_REFERENCE.MUTE);
      if (!checkToolsTransfer) {
        return;
      }
      setSvrMute(this);
    }else{
      triggerNotifications(this, MESSAGE_CODE.CALL_CONTROLS[10701], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
    }
  }
  stopStartRecording = () =>{
    if(verifyState(VERIFY_ACTIONS.STOP_START_RECORDING, this.sharedData.currentState)){
      const checkToolsTransfer = this.checkToolsTransferOptions(SHOW_TRANSFERS_BUTTONS_REFERENCE.RECORD);
      if (!checkToolsTransfer) {
        return;
      }
      setSvrStopStartRecording(this);
    }else{
      triggerNotifications(this, MESSAGE_CODE.CALL_CONTROLS[10701], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
    }
  }
  getIVRList = () => {
    if(verifyState(VERIFY_ACTIONS.IVR,this.sharedData.currentState)){
      const checkToolsTransfer = this.checkToolsTransferOptions(SHOW_TRANSFERS_BUTTONS_REFERENCE.IVR);
      if (!checkToolsTransfer) {
        return;
      }
      svrGetIVRList(this);
    }else{
      triggerNotifications(this, MESSAGE_CODE.CALL_CONTROLS[10704], MESSAGE_TYPE.WARN, MESSAGE_FROM.SDK);
    }
  }
  startIVR = (ivrID) => {
    if(verifyState(VERIFY_ACTIONS.IVR,this.sharedData.currentState)){
      const checkToolsTransfer = this.checkToolsTransferOptions(SHOW_TRANSFERS_BUTTONS_REFERENCE.IVR);
      if (!checkToolsTransfer) {
        return;
      }
      svrStartIVR(this, ivrID);
    }else{
      triggerNotifications(this, MESSAGE_CODE.CALL_CONTROLS[10704], MESSAGE_TYPE.WARN, MESSAGE_FROM.SDK);
    }
  }

  hangUp = () => {
    this.sharedData.setIsHangedUpByAgent(STATE_TO_PLAY_END_AUDIO.HANG_UP_AGENT);
    const message = {
      action:"HangUp",
      username: this.sharedData.getUserData().Login,
      userID: this.sharedData.getUserData().User_id,
      Subaction:"Call",
    };
    this.sendToRabbit(SM_QUEUE_SERVER, message);
  }

  updateDataCall = (data, camId, callKey) => {
    if(verifyState(VERIFY_ACTIONS.UPDATE_DATA, this.sharedData.currentState)){
      const checkToolsTransfer = this.checkToolsTransferOptions(SHOW_TRANSFERS_BUTTONS_REFERENCE.DATACALL);
      if (!checkToolsTransfer) {
        return;
      }
      setSvrUpdateData(this, data, camId, callKey);
    }else{
        triggerNotifications(this, MESSAGE_CODE.CALL_DATA[10301], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
      }
    }
  getLastCallDataInbound(){
    this.svrEvents.onLastCallDataInbound(this.sharedData.getLastCallDataInbound());
  }

  getLastCallDataOutbound(){
    this.svrEvents.onLastCallDataOutbound(this.sharedData.getLastCallDataOutbound());
  }
  hangUpAndLeaveMessage =() =>{
      this.sharedData.setIsHangedUpByAgent(STATE_TO_PLAY_END_AUDIO.HANG_UP_AGENT);
      svrHangUpAndLeaveMessage(this);
  }

  getOutboundCampaigns = () => {
    this.sendToRabbit(SM_QUEUE_SERVER,{
      action:"Api",
      username: this.sharedData.getUserData().Login,
      userID: this.sharedData.getUserData().User_id,
      Subaction:API_ENDPOINTS.CALL_OUT_CAMPAIGNS,
    });
  }

  makeManualCall = (phone, camId, callKey, data1) => {
    makeSvrManualCall(this, phone, camId, callKey, data1);
  }

  hangUpManualCall = () => {
    this.sharedData.setIsHangedUpByAgent(STATE_TO_PLAY_END_AUDIO.HANG_UP_AGENT);
    svrHangUpManualCall(this);
  }

  cancelScheduledManualCall = () => {
    svrCancelScheduledManualCall(this);
  }

  getUnavailables = () => {
    if(verifyState(VERIFY_ACTIONS.UNAVAILABLES, this.sharedData.currentState)){
      svrRequestUnavailables(this, UNAVAILABLES_ACTIONS.GET_UNAVAILABLES);
    }else{
      triggerNotifications(this, MESSAGE_CODE.UNAVAILABLES[11000], MESSAGE_TYPE.WARN, MESSAGE_FROM.SDK);
    }
  }
  setUnavailables = (notReadyID) => {
    if(verifyState(VERIFY_ACTIONS.UNAVAILABLES, this.sharedData.currentState)){
      svrRequestUnavailables(this, UNAVAILABLES_ACTIONS.SET_UNAVAILABLES, notReadyID);
    }else{
      triggerNotifications(this, MESSAGE_CODE.UNAVAILABLES[11000], MESSAGE_TYPE.WARN, MESSAGE_FROM.SDK);
    }
  }
  setReady = () => {
    if(this.sharedData.currentState !== LIST_STATES.PROBLEM || !this.sharedData.isProblemStatus){
      if(verifyState(VERIFY_ACTIONS.SET_READY,this.sharedData.currentState)){
        const userID = this.sharedData.user.User_id;
        const userName = this.sharedData.user.Login;
        const actionMessage = setSvrReady(userName, userID);
        this.sendToRabbit(SM_QUEUE_SERVER, actionMessage);
      }else{
        triggerNotifications(this, MESSAGE_CODE.UNAVAILABLES[11010], MESSAGE_TYPE.WARN, MESSAGE_FROM.SDK);
      }
    }
  }
  setReadyWithPassword=(agentPassword, adminPassword) => {
    if(verifyState(VERIFY_ACTIONS.SET_READY, this.sharedData.currentState)){
      const userID = this.sharedData.user.User_id;
      const userName = this.sharedData.user.Login;
      setSvrReadyWithPassword(this, agentPassword, adminPassword, userName, userID);
      const sendMessage = setSvrReady(userName, userID);
      if(this.state.sendRWPAction == 1){
        this.sendToRabbit(SM_QUEUE_SERVER, sendMessage);
      }
    }else{
      triggerNotifications(this, MESSAGE_CODE.UNAVAILABLES[11010], MESSAGE_TYPE.WARN, MESSAGE_FROM.SDK);
    }
  }
  exitDispositionMode = () => {
    if(verifyState(VERIFY_ACTIONS.EXIT_DISPOSITIONS_MODE, this.sharedData.currentState)){
      if(this.sharedCallOutData.exitDispositionsMode === true){
        const userID = this.sharedData.user.User_id;
        const requestTimeout = this.sharedData.requestTimeout;
        requestDispositions(this, userID, requestTimeout, DISPOSITIONS_ACTIONS.EXIT_DISPOSITION_MODE);
      }else{
        triggerNotifications(this, MESSAGE_CODE.DISPOSITIONS[11102], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
      }
    }else{
      triggerNotifications(this, MESSAGE_CODE.DISPOSITIONS[11103], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
    }
  }

  handleDispositionsRequest = (context, action) => { 
    if (verifyState(VERIFY_ACTIONS.DISPOSITIONS, context.sharedData.currentState)) { 
      const checkToolsTransfer = context.checkToolsTransferOptions(SHOW_TRANSFERS_BUTTONS_REFERENCE.DISPOSITION); 
      if (!checkToolsTransfer) { 
        return; 
      } 
      const userID = context.sharedData.user.User_id; 
      const requestTimeout = context.sharedData.requestTimeout; 
      requestDispositions(context, userID, requestTimeout, action); 
    } else { 
      triggerNotifications(context, MESSAGE_CODE.DISPOSITIONS[11100], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK); 
    }
  };

  getDispositionsAndNumbers = () => {
    this.handleDispositionsRequest(this, DISPOSITIONS_ACTIONS.GET_DISPOSITIONS_AND_NUMBERS);
  }
  getDispositions = () => {
    this.handleDispositionsRequest(this, DISPOSITIONS_ACTIONS.GET_DISPOSITIONS);
  }
  getPhoneNumbers = () => {
    this.handleDispositionsRequest(this, DISPOSITIONS_ACTIONS.GET_PHONE_NUMBERS);
  }
  saveDisposition = (dispositionID, subdispositionID) => {
    if(parseInt(dispositionID) > 0 || parseInt(subdispositionID) > 0){
      if(verifyState(VERIFY_ACTIONS.DISPOSITIONS, this.sharedData.currentState)){
        const checkToolsTransfer = this.checkToolsTransferOptions(SHOW_TRANSFERS_BUTTONS_REFERENCE.DISPOSITION);
        if (!checkToolsTransfer) {
          return;
        }
        saveSvrDisposition(this, dispositionID, subdispositionID);
      }else{
        triggerNotifications(this, MESSAGE_CODE.DISPOSITIONS[11100], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
      }
    }else{
      triggerNotifications(this, MESSAGE_CODE.DISPOSITIONS[11101], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
    }
  }
  getCallbacks = (campID) =>{
    const userID = this.sharedData.user.User_id;
    const requestTimeout = this.sharedData.requestTimeout;
    getSvrCallbacks(this, userID, requestTimeout, campID);
  }
  exitAssistedMode = () => {
    if(verifyState(VERIFY_ACTIONS.ASSISTED_MODE, this.sharedData.currentState)){
      console.info("[AgentSDK]: Exit Assisted Mode , changing to [Ready].");
      const userID = this.sharedData.user.User_id;
      const userName = this.sharedData.user.Login;
      const actionMessage = setSvrReady(userName, userID);
      this.sendToRabbit(SM_QUEUE_SERVER, actionMessage);   
      this.sharedData.isAssistedMode = false;
    }else{
      triggerNotifications(this, MESSAGE_CODE.DISPOSITIONS[11107], MESSAGE_TYPE.INFO, MESSAGE_FROM.SDK);
    }
  }
 reprogramInbound = (
    dispositionID, subdispositionID, dateCallback, telephone, existingNumber, callKey,
    data1, data2, data3, data4, data5) => {
      if(verifyState(VERIFY_ACTIONS.REPROGRAM, this.sharedData.currentState)){
        if (typeof telephone === 'string' && /^\d+$/.test(telephone)) { 
          if(this.sharedCallOutData.callType === 1){
            const userID = this.sharedData.user.User_id;
            const requestTimeout = this.sharedData.requestTimeout;
            reprogramToServer(this, dispositionID, subdispositionID, dateCallback, telephone, existingNumber, 
                              userID, requestTimeout, callKey, data1, data2, data3, data4, data5);
          } else {
            triggerNotifications(this, MESSAGE_CODE.REPROGRAM_CALL.INBOUND[11300], MESSAGE_TYPE.INFO, MESSAGE_FROM.SDK);
          }
        } else {
          triggerNotifications(this, MESSAGE_CODE.REPROGRAM_CALL.OUTBOUND[11202], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);  
        }
      }else{
        triggerNotifications(this, MESSAGE_CODE.REPROGRAM_CALL.OUTBOUND[11201], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
      }
  }
  reprogramOutbound = (
    dispositionID, subdispositionID, dateCallback, telephone, existingNumber) => {
      if(verifyState(VERIFY_ACTIONS.REPROGRAM, this.sharedData.currentState)){
        if (typeof telephone === 'string' && /^\d+$/.test(telephone)) { 
          if(this.sharedCallOutData.callType === 2){
            const userID = this.sharedData.user.User_id;
            const requestTimeout = this.sharedData.requestTimeout;
            reprogramToServer(this, dispositionID, subdispositionID, dateCallback, telephone, existingNumber, 
                              userID, requestTimeout, '', '', '', '', '', '');
          } else {
            triggerNotifications(this, MESSAGE_CODE.REPROGRAM_CALL.OUTBOUND[11200], MESSAGE_TYPE.INFO, MESSAGE_FROM.SDK);
          }
        } else {
          triggerNotifications(this, MESSAGE_CODE.REPROGRAM_CALL.OUTBOUND[11202], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);  
        }
      } else {
        triggerNotifications(this, MESSAGE_CODE.REPROGRAM_CALL.OUTBOUND[11201], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
      }
  }
  getCallsToday = () => {
    if(verifyState(VERIFY_ACTIONS.HISTORY_CALLS, 'All')){
      const userID = this.sharedData.user.User_id;
      const requestTimeout = this.sharedData.requestTimeout;
      getSvrCallsHistory(this, userID, requestTimeout);
    }else{
      triggerNotifications(this, MESSAGE_CODE.HISTORICAL_EVENTS[11401], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
    }
  }
  getUnavailablesHistory = () => {
    if(verifyState(VERIFY_ACTIONS.HISTORY_UNAVAILABLES, 'All')){
      const userID = this.sharedData.user.User_id;
      getSvrUnavailablesHistory(this, userID);
    }else{
      triggerNotifications(this, MESSAGE_CODE.HISTORICAL_EVENTS[11400], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
    }
  }
  setAudioPath = (pathAudio, secondsPlay) => {
    getAudioPath(this, pathAudio, secondsPlay);
  }
  getAdminsToChat = () => {
    if (!this.sharedData.isProblemStatus){
      if(verifyState(VERIFY_ACTIONS.CHAT_TO_ADMIN, this.sharedData.currentState)){
        const userID = this.sharedData.user.User_id;
        svrGetAdminsToChat(this, userID);
      }else{
        triggerNotifications(this, MESSAGE_CODE.CHAT[11602], MESSAGE_TYPE.WARN, MESSAGE_FROM.SDK);
      }
    }
  }
  sendChatToAdmin = (message, adminName) => {
    if(verifyState(VERIFY_ACTIONS.CHAT_TO_ADMIN, this.sharedData.currentState)){
      const userID = this.sharedData.user.User_id;
      svrSendChatToAdmin(this,message,adminName, userID);
    }else{
      triggerNotifications(this, MESSAGE_CODE.CHAT[11602], MESSAGE_TYPE.WARN, MESSAGE_FROM.SDK);
    }
  }
  getChats = () => {
    if (!this.sharedData.isProblemStatus) {
      if(verifyState(VERIFY_ACTIONS.CHAT_TO_ADMIN, this.sharedData.currentState)){
        svrGetChatLog(this);
      }else{
        triggerNotifications(this, MESSAGE_CODE.CHAT[11602], MESSAGE_TYPE.WARN, MESSAGE_FROM.SDK);
      }
    }
  }

  
  setParameters = () => {
    let parameterMizu = {};
    this.setInfoRabbitMQ();
		SOFTPHONE_PARAMETERS[SOFTPHONES_KEY.WEBRTC](this, parameterMizu);
	}
  
  setInfoRabbitMQ= () => {
    let rabbitParametters = this.sharedData.getGeneralPermissions()[199];
    let settingRabbit = rabbitParametters.split("|");
    let secureConnection = this.sharedData.getSecureConnection();
    let port = !secureConnection ? '15674' : settingRabbit[2];
    this.agentController.AgentObject.mq_port = port;
    this.agentController.AgentObject.mq_vhost = settingRabbit[3];
    this.agentController.AgentObject.mq_username = settingRabbit[4];
    this.agentController.AgentObject.mq_password = settingRabbit[5];
    this.agentController.AgentObject.mq_consumer =
    this.sharedData.getUserData().Login;
    this.agentController.AgentObject.mq_expiration = settingRabbit[6];
    this.agentController.AgentObject.mq_secureConnection = secureConnection;
    this.agentController.AgentObject.heartbeat = {
      outgoing: 20000,
      incoming: 20000,
    };
    this.agentController.AgentObject.mq_server = this.sharedData.getDomain();
  }

  connectRabbitMQ = () => {
    this.agentController.connectToRabbit(); 
    this.agentController.AgentObject.onConnected = () => {
      this.rabbitConnected = true;
      this.agentController.subscribeTopics(
        this.sharedData.getUserData().Login + "|"
      );
      this.sendToRabbit(
        SM_QUEUE_SERVER,
        messageLogin(this.agentController.getTimeStamp())
      );
    };

    this.agentController.AgentObject.onDisconnected = () => {
      this.messageDisconnect();
      this.agentController.disconnectBroker();
      this.rabbitConnected = false;
    };
    this.agentController.AgentObject.onMessage = (message) => {
      try {
        this.processMessage(JSON.parse(message));
      } catch (err) {
        console.warn("[App][loadAgentMethods] Message not process => " + message, err);
      }
    };
    this.agentController.AgentObject.onReconnected = () => {
        this.state.smReady = false;
        this.sendToRabbit(SM_QUEUE_SERVER, Reconnected());
				const reconnectedMessage = {
					statusCode: 8999,
					message: MESSAGE_CODE.CONNECTION_ALERTS[8999],
					type: 'Info'
				};
        this.svrEvents.onConnectionReconnected(reconnectedMessage)
        setTimeout(() => {
          if(!this.state.smReady){
            console.warn("[App][loadAgentMethods] Didn't revice reconnected package ");
            this.messageDisconnect();
          }
        }, 7000);
    };
    SOFTPHONE_CALLBACKS[SOFTPHONES_KEY.WEBRTC](this);
  };

  sendToRabbit = (topic, message) => {
      if (message) {
        delete message.ExpectsReponse;
        let obj = message;
        if (typeof message === "string") {
          obj = JSON.parse(message);
        }
        obj.timeSpam = this.agentController.getTimeStamp();
        message = JSON.stringify(obj);
        this.agentController.sendMessage(topic, message);
      }
    };

  processMessage=(message)=> {
		ProcessMessage(message, this);
	}


  parametersEngine = () => {
		let parameterEngine = this.sharedData.getGeneralPermissions()[143];
		const enginesPosition = parameterEngine.split(',');
		for (let i = 0; i < enginesPosition.length; i++) {
			const position = enginesPosition[i].split('|');
			this.Engines[position[0]] = position[1];
		}
	}

	setIpEngine = (engineId, ipKamailio) =>{
		let setting131 = this.sharedData.getGeneralPermissions()[131];
		const datoPBX = setting131.split('|');
		let CNF = 'PBX' + engineId + '@' + datoPBX[7];
		CNF = this.apiCont.cypher.md5Encryption(CNF);
		this.agentController.AgentObject.SIP_CNF_XD = CNF;
		this.agentController.AgentObject.SIP_KAMAILIO = '@' + ipKamailio + ':5061';
		this.agentController.AgentObject.SIP_iceCheckingTimeout = 750;
		this.agentController.UpdateParametersSIP();
	}

  
  callStateAction = (message) => {
    if(this.sharedData.isProblemStatus)
    {
      console.error('A problem has been detected with the agent. Please reload the page to resolve the issue.');
      return;
    }
    if(!STRATEGIES_STATES[message.currentState])
    {
      console.log('[SDK] [callStateAction] State Not implement ', message.currentState);
      return;
    }
    if (this.sharedData.getCurrentState() === LIST_STATES.WRAPUP && !this.sharedData.getIsRated()) {
      console.log('The call:' + this.callId + ' was not rated CurrentState:' + message.currentState);
    }

    STRATEGIES_STATES[message.currentState](message, this, document.getElementById('audio-call'));

    if (message.currentState === LIST_STATES.ERROR) {
      setTimeout(() => {
        location.reload();
      }, 2000);
    } else if ([USER_STATE.ERROR, LIST_STATES.ALERT, LIST_STATES.PROBLEM].indexOf(message.currentState) === -1) {
      this.sharedData.setCurrentState(message.currentState);
    }
    
	}

  actionsValitatingTelephony = () => {
		SOFTPHONE_VALIDATING[this.sharedData.getSoftPhone()](this);
	}

	checkOtherState = () => {
		if (!this.sharedData.getLogged()) {
			this.agentController.hangUp();
		}
	}

  makeCall = (callId) => {
		let _this = this;
		setTimeout(() => {
			_this.agentController.makeCall(callId);
		}, 200);
  }

  connectCall = (message, userID) => {
		SOFTPHONE_MAKECALL[this.sharedData.getSoftPhone()](this, message, userID);
	}

  messageDisconnect = () => {
		var _this = this;
		_this.numberReconnect = 0;
		if (_this.timerKeepAlive) {
			clearInterval(_this.timerKeepAlive);
			_this.timerKeepAlive = null;
		}
		_this.rabbitConnected = false;
    const objMessage = {
      statusCode: 1, 
      message: MESSAGE_CODE.CONNECTION_ALERTS[1],
      type: 'Error',
      developerHint: 'Execute method [ logout ] to start again.'
    };
    _this.errorEvents.onConnectionLost(objMessage);
    triggerNotifications(this, MESSAGE_CODE.CONNECTION_ALERTS[1], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
	}

}
